<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import VStack from "@magnit/core/src/components/VStack/VStack.vue";
import VStackItem from "@magnit/core/src/components/VStack/VStackItem.vue";
import type { IShopSelectStorePrompt } from "@magnit/unit-shop-select/src/shop-select.types";

defineProps<IShopSelectStorePrompt>();

const emit = defineEmits<{
  approve: [];
  reject: [];
}>();

const onApprove = () => emit("approve");
const onReject = () => emit("reject");
</script>

<template>
  <div class="store-select-prompt-content">
    <VText
      tag="div"
      font="title-large"
      class="store-select-prompt-content__title"
    >
      {{ address }}
    </VText>

    <VText tag="div" font="body-large-regular">
      {{ description }}
    </VText>
    <VText tag="div" font="body-large-regular">
      {{ subDescription }}
    </VText>

    <VStack
      class="store-select-prompt-content__buttons"
      :direction="{ xs: 'column', m: 'row' }"
      gap="16px"
    >
      <VStackItem :size="{ xs: 12, m: 6 }">
        <VButton full-width @click="onApprove">{{ approveLabel }}</VButton>
      </VStackItem>
      <VStackItem :size="{ xs: 12, m: 6 }">
        <VButton full-width theme="secondary" @click="onReject">
          {{ rejectLabel }}
        </VButton>
      </VStackItem>
    </VStack>
  </div>
</template>

<style lang="postcss" scoped>
.store-select-prompt-content {
  max-width: calc(440px - (var(--pl-unit-x4) * 2));
  padding: var(--pl-unit-x1);

  @media (--pl-viewport-from-ml) {
    max-width: calc(480px - (var(--pl-unit-x4) * 2));
  }

  &__title {
    margin-bottom: var(--pl-unit-x2);
    padding: var(--pl-unit-x1) 0;
  }

  &__buttons {
    margin-top: var(--pl-unit-x4);
  }
}
</style>
